// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"5b04adf1","300":"47be8810","342":"09f88288","376":"22dde070","648":"329e1e7e","684":"7cfaf935","691":"e9ef09f5","746":"63a19aa3","925":"3150f087","934":"84f90727"}[chunkId] + ".chunk.js";
};